const NAVIGATION_TABS = {
    HOME: 'HOME',
    SEARCH: 'SEARCH',
    SETTINGS: 'SETTINGS',
} as const;

export default NAVIGATION_TABS;
